import {
  AccessibilityAnchor,
  AccessibilityLink,
} from "@faire/deprecated-retailer-visitor-shared/lib/AccessibilityLink";
import { Message } from "@faire/slate/foundation/color";
import { trackLoggedOutRetailersFooterLinksActionCategoryClick } from "@faire/web-api--source/events/loggedOutRetailers/actionCategoryClick/footerLinks";
import { trackEventOnClick } from "@faire/web/common/trackEvent";
import { Badge } from "@faire/web/slate/deprecated/Badge";
import { Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

export interface IFooterLink {
  name: string;
  to: string;
  target: "_blank" | undefined;
  isExternal: boolean;
  shouldShow?: boolean;
  eventPath?: string;
  isNew?: boolean;
  peteEvent?: () => void;
}
export const SectionLink: React.FC<{
  link: IFooterLink;
}> = ({ link }) => {
  if (!link.shouldShow) {
    return null;
  }

  const handleLinkClick = () => {
    if (link.peteEvent) {
      link.peteEvent();
    }
    if (link.eventPath) {
      trackEventOnClick(link.eventPath);
    }

    trackLoggedOutRetailersFooterLinksActionCategoryClick(link.to);
  };

  if (link.isExternal) {
    return (
      <SectionItem key={link.name}>
        <AccessibilityAnchor
          href={link.to}
          target={link.target}
          rel="noopener noreferrer"
          onClick={handleLinkClick}
        >
          <LinkText>{link.name}</LinkText>
        </AccessibilityAnchor>
      </SectionItem>
    );
  }

  return (
    <SectionItem key={link.name}>
      <Row align="center">
        <AccessibilityLink
          to={link.to}
          target={link.target}
          onClick={handleLinkClick}
        >
          <LinkText>{link.name}</LinkText>
        </AccessibilityLink>
        {link.isNew ? (
          <>
            <Spacer size="1x" />
            <NewBadge content="New" backgroundColor={Message.surface.success} />
          </>
        ) : null}
      </Row>
    </SectionItem>
  );
};
const LINK_MARGIN = 3;
const SectionItem = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: ${LINK_MARGIN}px 0;
`;

const LinkText = styled(Typography)`
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
`;

const NewBadge = styled(Badge)`
  width: 38px;
  height: ${getSpacing("3x")};
`;
